// @ts-nocheck
import React, { useState } from 'react';
import './StickyNoteDialog.css';

type NoteType = 'question' | 'idea' | 'important';

interface StickyNoteData {
  noteType: NoteType;
  content: string;
  selectedText: string;
}

interface StickyNoteDialogProps {
  show: boolean;
  selectedText: string;
  onSave: (data: StickyNoteData) => void;
  onCancel: () => void;
  [key: string]: any;
}

const StickyNoteDialog: React.FC<StickyNoteDialogProps> = ({ show, selectedText, onSave, onCancel }) => {
  const [noteType, setNoteType] = useState<NoteType>('question');
  const [content, setContent] = useState('');

  if (!show) return null;

  const handleSave = () => {
    if (!content.trim()) {
      alert('请输入内容');
      return;
    }

    onSave({
      noteType,
      content: content.trim(),
      selectedText
    });

    setContent('');
    setNoteType('question');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      handleSave();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div className="sticky-note-overlay" onClick={onCancel}>
      <div className="sticky-note-dialog" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <div className="sticky-note-header">
          <h4>📌 添加便利贴</h4>
          <button className="close-btn" onClick={onCancel}>×</button>
        </div>

        {selectedText && (
          <div className="sticky-note-context">
            <small>选中内容：</small>
            <div className="context-preview">
              {selectedText.substring(0, 100)}
              {selectedText.length > 100 ? '...' : ''}
            </div>
          </div>
        )}

        <div className="sticky-note-body">
          <div className="note-type-selector">
            <label>类型：</label>
            <button
              className={`type-btn type-question ${noteType === 'question' ? 'active' : ''}`}
              onClick={() => setNoteType('question')}
            >
              📝 疑问
            </button>
            <button
              className={`type-btn type-idea ${noteType === 'idea' ? 'active' : ''}`}
              onClick={() => setNoteType('idea')}
            >
              💡 想法
            </button>
            <button
              className={`type-btn type-important ${noteType === 'important' ? 'active' : ''}`}
              onClick={() => setNoteType('important')}
            >
              ⚠️ 重点
            </button>
          </div>

          <div className="note-input-area">
            <textarea
              value={content}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setContent(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="输入你的想法、疑问或重点标记..."
              autoFocus
              maxLength={500}
            />
            <div className="char-count">
              {content.length} / 500
            </div>
          </div>
        </div>

        <div className="sticky-note-footer">
          <button className="cancel-btn" onClick={onCancel}>
            取消
          </button>
          <button
            className="save-btn"
            onClick={handleSave}
            disabled={!content.trim()}
          >
            保存 (Ctrl+Enter)
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyNoteDialog;
